<template>
   <FormModal v-if="showPopup" :closePopup="closePopup" />

<div >
  <Navbar :openPopup="openPopup" />
  <!-- <PageTitle :data="{ pageTitle: 'Career' }" /> -->
  <ChallengesAndTrack />
   <Features />  
   <Blog/>
   <AppProgress />
   <FooterStyleFour />
  </div>
</template>

<script>
import Navbar from "../Layout/Navbar";
import PageTitle from "../Common/PageTitle";
import AppProgress from "../Career/AppProgress.vue";
import Features from '../Career/secoundbox.vue'
 
import ChallengesAndTrack from '../Career/firstbox.vue'
 
import Blog from '../Career/Partner.vue'
import FooterStyleFour from "../Layout/FooterStyleFour";
import FormModal from "../HomeThree/FormModal.vue";

export default {
  name: "CareerPage",
  components: {
    Navbar,
    PageTitle,
    AppProgress,
    Features,
    Blog,
    ChallengesAndTrack,
    
    
    FooterStyleFour,
    FormModal
},
data(){
    return{
        showPopup:false
    }
},
  methods: {
    openPopup(){
     this.showPopup  = true
    },
    closePopup(){
     this.showPopup= false
    },
        async gettitle() {
            // Set comprehensive SEO meta tags
            document.title = "Career Opportunities - Join Our Team | Meander Software";
            
            // Helper to set or update a meta tag
            function setMeta(name, content, attr = 'name') {
              let element = document.querySelector(`meta[${attr}="${name}"]`);
              if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attr, name);
                document.head.appendChild(element);
              }
              element.setAttribute('content', content || '');
            }

            // Set basic meta tags
            setMeta('title', 'Career Opportunities - Join Our Team | Meander Software');
            setMeta('description', 'Explore exciting career opportunities at Meander Software. Join our dynamic team of professionals and work on innovative software development projects. Apply now for rewarding positions.');
            setMeta('keywords', 'career opportunities, software jobs, development positions, tech careers, meander software jobs, software development careers');

            // Open Graph tags
            setMeta('og:title', 'Career Opportunities - Join Our Team | Meander Software', 'property');
            setMeta('og:description', 'Explore exciting career opportunities at Meander Software. Join our dynamic team of professionals and work on innovative software development projects.', 'property');
            setMeta('og:type', 'website', 'property');
            setMeta('og:url', window.location.href, 'property');
            setMeta('og:image', 'https://meander.software/og-default-image.jpg', 'property');
            setMeta('og:image:width', '1200', 'property');
            setMeta('og:image:height', '630', 'property');
            setMeta('og:image:alt', 'Career Opportunities - Join Our Team | Meander Software', 'property');

            // Twitter Card tags
            setMeta('twitter:title', 'Career Opportunities - Join Our Team | Meander Software', 'name');
            setMeta('twitter:description', 'Explore exciting career opportunities at Meander Software. Join our dynamic team of professionals and work on innovative software development projects.', 'name');
            setMeta('twitter:image', 'https://meander.software/og-default-image.jpg', 'name');
            setMeta('twitter:image:alt', 'Career Opportunities - Join Our Team | Meander Software', 'name');
            setMeta('twitter:card', 'summary_large_image', 'name');
            setMeta('twitter:site', '@meandersoftware', 'name');
            setMeta('twitter:creator', '@meandersoftware', 'name');

            // Update canonical URL
            let canonical = document.querySelector('link[rel="canonical"]');
            if (canonical) {
              canonical.setAttribute('href', window.location.href);
            } else {
              canonical = document.createElement('link');
              canonical.setAttribute('rel', 'canonical');
              canonical.setAttribute('href', window.location.href);
              document.head.appendChild(canonical);
            }
        }
    },
    mounted: function() { // Use a regular function here
        this.gettitle();
    }
};
</script>
